export default __webpack_public_path__ + "static/media/103.08148c87.jpg";